import { render, staticRenderFns } from "./ToolbarAPI.vue?vue&type=template&id=3c946970&scoped=true&"
import script from "./ToolbarAPI.vue?vue&type=script&lang=js&"
export * from "./ToolbarAPI.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarAPI.vue?vue&type=style&index=0&id=3c946970&prod&scoped=true&lang=css&"
import style1 from "./ToolbarAPI.vue?vue&type=style&index=1&id=3c946970&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c946970",
  null
  
)

export default component.exports